import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxList  from './components/vx-list/VxList.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from './components/FeatherIcon.vue'
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import FileSelection from './components/letstream/form-components/FileSelection/FileSelection.vue'
import SelectDate from './components/letstream/ls-select-date/SelectDate'
import InputSelect from './components/letstream/ls-select/InputSelect'
import FormatText from './components/letstream/ls-text-formatter/FormatText'
import SelectForeign from './components/letstream/ls-select-foreign/SelectForeign'

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)

Vue.component('SelectDate', SelectDate)
Vue.component('InputSelect', InputSelect)
Vue.component('FileSelection', FileSelection)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('FormatText', FormatText)

Vue.component('SelectForeign', SelectForeign)

// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    }),
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    }),
  },
});

Vue.component(vSelect)

var cloneDeep = require('lodash.clonedeep');
var mergeDeep = require('lodash.merge');
var isEqual = require('lodash.isequal');
var sprintf = require('sprintf-js').sprintf

Vue.mixin({
  methods: {
    deepclone: (object) => cloneDeep(object),
    deepmerge: (object1, object2) => mergeDeep(object1, object2),
    isEqual: (object1, object2) => isEqual(object1, object2),
    sprintf: (...args) => sprintf(...args),
    findParent: (ele, class_name) => {
      let parentElement = ele
      let rootElement = document.body;

      while(true) {
        parentElement = parentElement.parentElement;
        
        if(parentElement.classList.contains(class_name)) {
          return parentElement
        }
        
        if (parentElement === rootElement)
          return null
      }
    }
  }
})
